/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Support_EmailInputs */

const en_fc_support_email = /** @type {(inputs: Fc_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@getfilmcraft.org`)
};

/**
* | output |
* | --- |
* | "support@getfilmcraft.org" |
*
* @param {Fc_Support_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_support_email = /** @type {((inputs?: Fc_Support_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Support_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_support_email(inputs)
});
export { fc_support_email as "fc.support.email" }